import React, { useState, useEffect } from "react";
import { FiSettings, FiTrash2, FiX } from "react-icons/fi";
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Импортируем Link
import Header from '../components/Admin/Header'; // Импортируем Header
import Sidebar from '../components/Admin/Sidebar'; // Импортируем Sidebar
import { $host } from "../http";

const ScriptsPage = () => {
  // Состояния модальных окон, скриптов и ключевых слов
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [scripts, setScripts] = useState([]);
  const [currentKeyword, setCurrentKeyword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [editingScript, setEditingScript] = useState(null);
  const [newScript, setNewScript] = useState({
    isWelcome: false,
    keywords: [],
    question: "",
    responses: [""],
  });

  // Добавление ключевого слова
  const handleAddKeyword = () => {
    if (currentKeyword.trim() && !newScript.keywords.includes(currentKeyword.trim())) {
      setNewScript(prev => ({ ...prev, keywords: [...prev.keywords, currentKeyword.trim()] }));
      setCurrentKeyword("");
    }
  };

  // Удаление ключевого слова
  const handleRemoveKeyword = (keywordToRemove) => {
    setNewScript(prev => ({ ...prev, keywords: prev.keywords.filter(keyword => keyword !== keywordToRemove) }));
  };

  // Получение скриптов
  const fetchScripts = async () => {
    try {
      const response = await $host.get("/api/admin/scripts");

      setScripts(response.data);
    } catch (error) {
      console.log("Ошибка:", error);
    }
  };

  // Создание скрипта
  const handleCreateScript = async () => {
    try {
      const response = await $host.request("/api/admin/scripts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(newScript),
      });

      const createdScript = response.data;
      setScripts([...scripts, createdScript]);
      setNewScript({ id: "", isWelcome: false, keywords: [], question: "", responses: [""] });
      setIsCreateModalOpen(false);
      fetchScripts();
    } catch (error) {
      setErrorMessage(error.message || "Произошла ошибка, попробуйте снова.");
    }
  };

  // Редактирование скрипта
  const handleEditScript = async () => {
    try {
      const response = await $host.request(`/api/admin/scripts/${editingScript.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(editingScript),
      });

      const updatedScript = response.data;
      setScripts(scripts.map(script => (script.id === updatedScript.id ? updatedScript : script)));
      setIsEditModalOpen(false);
      setEditingScript(null);
      fetchScripts();
    } catch (error) {
      setErrorMessage(error.message || "Произошла ошибка, попробуйте снова.");
    }
  };

  // Удаление скрипта
  const handleDeleteScript = async (id) => {
    try {
      await $host.request(`/api/admin/scripts/${id}`, {
        method: "DELETE",
      });
      setScripts(scripts.filter(script => script.id !== id));
    } catch (error) {
      console.log("Ошибка при удалении скрипта:", error);
    }
  };

  useEffect(() => {
    fetchScripts();
  }, []);

  return (
    <div>
      <Header />   {/* Используем компонент Header */}
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar /> {/* Используем компонент Sidebar */}

        {/* Main Content */}
        <main className="flex-1 p-8 bg-[#F3F1FB4D]">
          {/* Breadcrumbs */}
          <nav className="w-full rounded-md mb-8">
            <ol className="list-reset flex">
              <li>
                <Link to="/scripts" className="text-[black] text-primary transition duration-150 ease-in-out hover:text-primary-accent-300 focus:text-primary-accent-300 active:text-primary-accent-300 motion-reduce:transition-none dark:text-primary-400">
                  Скрипты
                </Link>
              </li>
              <li>
                <span className="mx-2 text-neutral-400">/</span>
              </li>
              <li className="text-neutral-400">Всего {scripts.length} скриптов</li>
            </ol>
          </nav>

          <button
            onClick={() => setIsCreateModalOpen(true)}
            className="w-full bg-[#6446C314] hover:bg-[#6446C31F] text-[#6446C3] font-semibold py-4 px-6 rounded-lg transition-colors focus:outline-none mb-4 flex items-center justify-center"
            aria-label="Добавить скрипт"
          >
            <FaPlus className="text-1xl" />
          </button>

          {/* Scripts Section */}
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Скрипты</h1>
            <div className="space-y-4">
              {scripts.map((script) => (
                <div key={script.id} className="flex items-center justify-between p-4 bg-[#6446C314] rounded-lg mb-2">
                  <span className="font-bold text-[#6446C3]">{script.question}</span>
                  <div className="flex space-x-2 items-center">
                    <span className="mr-10 text-gray-600">
                      <span className="font-medium text-[#6446C3] mr-2">{script.keywords ? script.keywords.length : 0}</span>
                      ключевых слова
                    </span>
                    <button onClick={() => { setEditingScript(script); setIsEditModalOpen(true); }} className="p-2 text-gray-600 hover:text-blue-600">
                      <FiSettings />
                    </button>
                    <button onClick={() => handleDeleteScript(script.id)} className="p-2 text-gray-600 hover:text-red-600">
                      <FiTrash2 />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>

        {/* Create Script Modal */}
        {isCreateModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-[60%]">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-xl font-medium">Создать скрипт</h1>
                <button onClick={() => { 
                  setIsCreateModalOpen(false); 
                  setErrorMessage(""); 
                  setCurrentKeyword(""); // Очистка текущего ключевого слова
                  setNewScript({ isWelcome: false, keywords: [], question: "", responses: [""] }); // Сброс данных
                }} className="text-gray-500 text-2xl">
                  <FiX />
                </button>
              </div>
              <div className="space-y-4">
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                
                {/* Ввод вопроса */}
                <div className="flex flex-col mb-2">
                  <input 
                    type="text" 
                    value={newScript.question} 
                    onChange={(e) => setNewScript({ ...newScript, question: e.target.value })} 
                    placeholder="Название скрипта" 
                    className="outline-none w-full text-[#363645] text-[24px] pl-0 bg-transparen" 
                    style={{ borderBottom: '1px solid #6446C3' }} 
                  />
                </div>

                {/* Ввод ответов */}
                <div className="flex flex-col mb-4">
                  <textarea 
                    value={newScript.responses.join("\n\n")} // Используем двойной перенос строки для отображения абзацев
                    onChange={(e) => setNewScript({ 
                      ...newScript, 
                      responses: e.target.value.split("\n\n").filter(line => line.trim() !== "")
                    })} 
                    placeholder="Введите ответы, каждый абзац через пустую строку" 
                    className="bg-[#6446C314] border-b border-[#6446C3] outline-none rounded-[12px] w-full h-[139px] text-[#6446C3]" 
                    rows={5} 
                  />
                </div>

                {/* Ввод ключевых слов */}
                <div className="relative">
                  <input 
                    type="text" 
                    value={currentKeyword} 
                    onChange={(e) => setCurrentKeyword(e.target.value)} 
                    placeholder="Введите ключевое слово" 
                    className="bg-[#6446C314] border-b border-[#6446C3] outline-none rounded-[12px] w-full h-[42px] pl-4 pr-16 text-[#6446C3]" 
                  />
                  <button 
                    onClick={handleAddKeyword} 
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-[#6446C3] text-white rounded-[8px] px-3 h-[30px] mr-2"
                  >
                    Добавить
                  </button>
                </div>

                {/* Список добавленных ключевых слов */}
                {newScript.keywords.length > 0 && (
                  <div className="flex flex-wrap mb-4">
                    {newScript.keywords.map((keyword, index) => (
                      <div key={index} className="flex items-center bg-[#D8D0FA] rounded-[8px] px-3 py-2 mr-2 mb-2">
                        <span>{keyword}</span>
                        <button onClick={() => handleRemoveKeyword(keyword)} className="ml-2 text-red-500">
                          <FiTrash2 />
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <button onClick={handleCreateScript} className="bg-[#6446C3] w-full h-[42px] text-white rounded-[16px]">Создать скрипт</button>
              </div>
            </div>
          </div>
        )}

        {/* Edit Script Modal */}
        {isEditModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-[60%]">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-xl font-medium">Редактировать скрипт</h1>
                <button onClick={() => { 
                  setIsEditModalOpen(false); 
                  setErrorMessage(""); 
                }} className="text-gray-500 text-2xl">
                  <FiX />
                </button>
              </div>
              <div className="space-y-4">
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}

                {/* Ввод вопроса */}
                <div className="flex flex-col mb-2">
                  <input 
                    type="text" 
                    value={editingScript.question} 
                    onChange={(e) => setEditingScript({ ...editingScript, question: e.target.value })} 
                    placeholder="Название скрипта" 
                    className="outline-none w-full text-[#363645] text-[24px] pl-0 bg-transparen" 
                    style={{ borderBottom: '1px solid #6446C3' }}
                  />
                </div>

                {/* Ввод ответов */}
                <div className="flex items-center mb-2">
                  <textarea 
                    value={editingScript.responses.join(", ")} 
                    onChange={(e) => setEditingScript({ ...editingScript, responses: e.target.value.split(", ") })} 
                    placeholder="Текст ответа" 
                    className="bg-[#6446C314] border-b border-[#6446C3] outline-none rounded-[12px] w-full h-[139px] text-[#6446C3]" 
                  />
                </div>

                {/* Ввод ключевых слов */}
                <div className="relative">
                  <input 
                    type="text" 
                    value={currentKeyword} 
                    onChange={(e) => setCurrentKeyword(e.target.value)} 
                    placeholder="Введите ключевое слово" 
                    className="bg-[#6446C314] border-b border-[#6446C3] outline-none rounded-[12px] w-full h-[42px] pl-4 pr-16 text-[#6446C3]" 
                  />
                  <button 
                    onClick={() => {
                      const keywords = Array.isArray(editingScript.keywords) ? editingScript.keywords : [];
                      if (currentKeyword.trim() && !keywords.includes(currentKeyword.trim())) {
                        setEditingScript(prev => ({
                          ...prev,
                          keywords: [...keywords, currentKeyword.trim()]
                        }));
                        setCurrentKeyword("");
                      }
                    }} 
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-[#6446C3] text-white rounded-[8px] px-3 h-[30px] mr-2"
                  >
                    Добавить
                  </button>
                </div>

                {/* Displaying keywords from the editingScript */}
                {editingScript.keywords && editingScript.keywords.length > 0 && (
                  <div className="flex flex-wrap">
                    {editingScript.keywords.map((keyword, index) => (
                      <div key={index} className="flex items-center bg-[#D8D0FA] rounded-[8px] px-3 py-2 mr-2 mb-2">
                        <span>{keyword}</span>
                        <button onClick={() => {
                          setEditingScript(prev => ({
                            ...prev,
                            keywords: prev.keywords.filter(k => k !== keyword)
                          }));
                        }} className="ml-2 text-red-500">
                          <FiTrash2 />
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <button onClick={handleEditScript} className="bg-[#6446C3] w-full h-[42px] text-white rounded-[16px]">Обновить скрипт</button>
              </div>
            </div>
          </div>
        )}
      </div>    
    </div>
  );
};

export default ScriptsPage;
